import { Chatroom } from '../../models';
import { useState } from 'react';

type State = { isOpen: boolean; room: Chatroom | null | undefined };
type ToggleFunction = (display: boolean, room?: Chatroom) => void;

export function useOpenActivateConfirmModal(): [State, ToggleFunction] {
  const [state, setState] = useState<{
    isOpen: boolean;
    room: Chatroom | undefined;
  }>({
    isOpen: false,
    room: undefined,
  });

  const toggle = (isOpen: boolean, room?: Chatroom) => {
    setState(() => ({ isOpen, room }));
  };

  return [state, toggle];
}
